function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
function dateParser(timestamp) {
  var messageDate = moment(timestamp, "YYYY-MM-DD HH:mm:ss").fromNow();
  if (messageDate.includes("year")) return moment(timestamp, "YYYY-MM-DD HH:mm:ss").fromNow(true);
  if (messageDate.includes("month")) return moment(timestamp, "YYYY-MM-DD HH:mm:ss").fromNow(true).replace("a", "1");
  if (messageDate.includes("day")) return moment(timestamp, "YYYY-MM-DD HH:mm:ss").fromNow(true);
  if (messageDate.includes("hour")) {
    if (messageDate.includes("hours")) return moment(timestamp, "YYYY-MM-DD HH:mm:ss").fromNow(true);
    return moment(timestamp, "YYYY-MM-DD HH:mm:ss").fromNow(true).replace("an", "1");
  }
  if (messageDate.includes("minutes") || messageDate.includes("minute")) return moment(timestamp, "YYYY-MM-DD HH:mm:ss").fromNow(true);
  if (messageDate.includes("seconds")) return "1 min";
  return "";
}
function Clock(_ref) {
  var timestamp = _ref.timestamp;
  var _useState = useState(dateParser(timestamp)),
    _useState2 = _slicedToArray(_useState, 2),
    currentCount = _useState2[0],
    setCount = _useState2[1];
  useEffect(function () {
    var interval = setInterval(function () {
      return setCount(dateParser(timestamp));
    }, 60000);
    return function () {
      clearInterval(interval);
    };
  }, [currentCount]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, dateParser(timestamp));
}
export default Clock;
Clock.propTypes = {
  timestamp: PropTypes.string
};